import { render } from "./DriveTraffic.vue?vue&type=template&id=2740439f&scoped=true"
import script from "./DriveTraffic.vue?vue&type=script&lang=js"
export * from "./DriveTraffic.vue?vue&type=script&lang=js"

import "./DriveTraffic.vue?vue&type=style&index=0&id=2740439f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2740439f"]])

export default __exports__